import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderTypesAdapter = getAdapter({ idFieldName: 'value' });

const orderTypesSlice = createSlice({
    name: 'orderTypes',
    initialState: orderTypesAdapter.getInitialState(),
    reducers: {
        setOrderTypes: (state, { payload: { orderTypes } }) => {
            orderTypesAdapter.setAll(state, orderTypes);
        },
    },
});

const selectors = orderTypesAdapter.getSelectors(({ orderTypes }) => orderTypes);

export const getAllOrderTypes = (state) => selectors.selectAll(state);

export const {
    setOrderTypes,
} = orderTypesSlice.actions;

export default orderTypesSlice.reducer;
